import { AxiosRequestConfig } from 'axios';
import { getFileType } from 'src/libraries/file.library';
import { commonClient, httpClient } from 'src/libraries/http.library';
import {
  FileSchema,
  FileUploadListPayload,
  FileDownloadPayloadSchema,
  IFile,
  FileDeletePayload,
} from 'src/models/file.model';

const http = httpClient();
const common = commonClient();

const services = {
  uploadPOST: async (file: File, options: AxiosRequestConfig = {}) => {
    const formData = new FormData();
    formData.append('file', file);

    return common.post(
      `/files/upload/aavsscg/${getFileType(file.name)}`,
      formData,
      FileSchema,
      options
    );
  },

  downloadGET: async (fileName: string, docName: string) => {
    return common.get(
      `/files/download/aavsscg/${fileName}?userFileName=${encodeURIComponent(docName)}`,
      {},
      FileDownloadPayloadSchema
    );
  },

  listByRequestIdGET: async (requestId: number) => {
    return http.get('/uploads', { requestId, limit: 0 }, FileUploadListPayload);
  },

  addPOST: async (data: IFile) => {
    return http.post('/uploads', data, FileSchema);
  },

  dataDELETE: async (uploadId: number) => {
    return http.delete(`/uploads/${uploadId}`, FileDeletePayload);
  },

  uploadDELETE: async (fileName: string) => {
    return common.delete(`/files/aavsscg/${fileName}`, FileSchema);
  },
};

export default services;
